import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../SideBar/SideBar';
import Topbar from '../TopBar/Topbar';
import styles from './MainLayout.module.css';

const MainLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const isLogin = Boolean(localStorage.getItem("token"));

    if (!isLogin) {
        return <Navigate to="/login" />;
    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className={styles.layout}>
            <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
            <Topbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            <main className={`${styles.main} ${isSidebarOpen ? styles.expanded : styles.collapsed}`}>
                <Outlet />
            </main>
        </div>
    );
};

export default MainLayout;